import { CacaoService } from './cacao.service';
import { AuthService } from './auth.service';
import { UsersService } from './users.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreCollection,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Card } from '../../shared/models/cards';

@Injectable({
  providedIn: 'root'
})
export class CardsService {
  private api = environment.api;
  private domain = '/api/card/';
  private domainCacao = '/api/cacao/';

  cardsCollection: AngularFirestoreCollection<Card>;
  cardDoc: AngularFirestoreDocument<Card>;
  cards: Observable<Card[]>;
  card: Observable<Card>;


  constructor(
    private afs: AngularFirestore,
    private http: HttpClient,
    private userService: UsersService,
    private authService: AuthService,
    private cacaoService: CacaoService,
  ) {
    this.cardsCollection = this.afs.collection('cards');
  }

  getCards(): Observable<Card[]> {
    this.cards = this.cardsCollection.valueChanges({ idField: 'id'})
    console.log('Mis tarjetas', this.cards);
    return this.cards;
  }

  newCard(
      card: Card
    ): Promise<{ card: Card } | any> {
    return new Promise(async (resolve, reject) => {
      try {
        const savingNewCard = await this.cardsCollection.add(
          JSON.parse(JSON.stringify(card))
        );
        resolve(savingNewCard.id);
        const itemObj: any = {};
        itemObj.id = savingNewCard.id;
        this.updateCard(itemObj.id, itemObj);
      } catch (err) {
        reject(err);
      }
    });
  }

  getCard(id: string): Observable<Card> {
    this.cardDoc = this.afs.doc<Card>(`cards/${id}`);
    this.card = this.cardDoc.snapshotChanges().pipe(
      map((action) => {
        if (action.payload.exists === false) {
          return null;
        } else {
          const data = action.payload.data() as Card;
          //data.id = action.payload.id;
          return data;
        }
      })
    );
    return this.card;
  }

   async updateCard(
     docId: string,
     newData: any
   ): Promise<{ card: Card } | any> {
     try {
       let response = await this.afs.doc(`cards/${docId}`).update(newData);
       return response;
     } catch (error) {
       console.log(error);
     }
   }

  async deleteCard(
    docId: string
   ): Promise<{ card: Card } | any> {
    try {
      let response = await this.afs.doc(`cards/${docId}`).delete();
      return response;
    } catch (error) {
      console.log(error);
    }
  }

  add(_user,_cardNumber) {
    return this.http.post(this.api + this.domain + 'add', {
      userId: _user.id,
      cardNumber: _cardNumber
    });
  }

  activate(_userId, _programId, _cardNumber) {
    return this.http.post(this.api + this.domain + 'activate', {
      userId: _userId,
      cardNumber: _cardNumber
    });
  }
  lock(_userId,_cardNumber, _commentsCode?) {
    return this.http.post(this.api + this.domain + 'lock', {
      userId: _userId,
      cardNumber: _cardNumber,
      commentsCode: _commentsCode ? _commentsCode : '004' 
    });
  }

  unlock(_userId ,_cardNumber, _commentsCode?) {
    return this.http.post(this.api + this.domain + 'unlock', {
      userId: _userId,
      cardNumber: _cardNumber,
      commentsCode: _commentsCode ? _commentsCode : '004' 
    });
  }

  getNIP(_cardNumber) {
    return this.http.post(this.api + this.domain + 'nip', {
      cardNumber: _cardNumber
    });
  }

  updateNIP(_userId,_cardNumber, _nip) {
    console.log(_cardNumber, _nip);
    return this.http.post(this.api + this.domain + 'nip/update', {
      userId: _userId,
      cardNumber: _cardNumber,
      nip: _nip
    });
  }

  updateStatus(_userId, _cardNumber, _statusId) {
    console.log(this.api + this.domain + 'updateStatus');
    return this.http.post(this.api + this.domain + 'updateStatus', {
      userId: _userId,
      cardNumber: _cardNumber,
      status: _statusId
    });
  }

  runActivation(_userId, _programId, _cardNumber) {
    return this.http.post(this.api + this.domain + 'runActivation', {
      userId: _userId,
      programId: _programId,
      cardNumber: _cardNumber
    });
  }

  async runActivateCardUser(_user: any, _card: any, _programId: any) {
    var promise = new Promise(async (resolve, reject) => {
      try {
        if(!_user) throw ({error: true, message: 'Usuario es requerido.'})
        if(!_card) throw ({error: true, message: 'Tarjeta es requerida.'})
        console.log(_user);
        console.log(_card);

        const _runActivation: any = await this.runActivation(_user.id, _programId, _card.cardNumber).toPromise();
        if(!_runActivation || _runActivation.error) throw _runActivation;
        /*
        // Vincular la Información del Usuario con la Tarjeta(Cacao)
        let _ActualizarDatosCliente: any = await this.cacaoService.ActualizarDatosCliente(_card,_user).toPromise();
        console.log(_ActualizarDatosCliente);
        if(!_ActualizarDatosCliente || _ActualizarDatosCliente.error) throw _ActualizarDatosCliente;

        // Agrgear Tarjeta a Usuario (Firebase)
        let _AgragrTarjetaUsuario: any = await this.userService.updateCard(_user.id, _programId, _card).toPromise();
        console.log(_AgragrTarjetaUsuario);
        if(!_AgragrTarjetaUsuario || _AgragrTarjetaUsuario.error) throw _AgragrTarjetaUsuario;

        // Activar Tarjeta (Cacao)
        let _ActivarTarjeta: any = await this.activate(_user.id, _programId , _card.cardNumber).toPromise();
        console.log(_ActivarTarjeta);
        if(!_ActivarTarjeta || _ActivarTarjeta.error) throw _ActivarTarjeta;

        // Actualizar Estatus de Tarjeta a Activa (Firebase) 
        let _UpdateStatusCard: any = await this.updateStatus(_user.id, _card.cardNumber, 2).toPromise();
        console.log(_UpdateStatusCard);
        if(!_UpdateStatusCard || _UpdateStatusCard.error) throw _UpdateStatusCard;

        */
        //Obtener la informacion del usaurio
        let userData = await this.userService.getUserAsPromise(_user.id);
        console.log(userData);
        
        resolve({
          message: `Se ha asignado y activado la tarjeta "${ _card.cardNumber}" al usaurio "${userData.name+' '+userData.lastName + ' '+userData.secondLastName}" con éxito.`,
          user: userData,
        });
      } catch(err) {
        reject(err);
      }
    });
    return promise;
    try {
      console.log(_user);
      console.log(_card);
      /*
      let _program: any = {};
      // Vincular la Información del Usuario con la Tarjeta(Cacao)
      let _ActualizarDatosCliente: any = await this.cacaoService.ActualizarDatosCliente(_card,_user).toPromise();
      if(!_ActualizarDatosCliente || _ActualizarDatosCliente.error) throw _ActualizarDatosCliente;

      // Agrgear Tarjeta a Usuario (Firebase)
      let _AgragrTarjetaUsuario: any = await this.userService.updateCard(_user.id, _program.programId, _card).toPromise();
      if(!_AgragrTarjetaUsuario || _AgragrTarjetaUsuario.error) throw _AgragrTarjetaUsuario;

      // Activar Tarjeta (Cacao)
      let _ActivarTarjeta: any = await this.activate(_card.cardNumber).toPromise();
      if(!_ActivarTarjeta || _ActivarTarjeta.error) throw _ActivarTarjeta;

      // Actualizar Estatus de Tarjeta a Activa (Firebase) 
      let _UpdateStatusCard: any = await this.updateStatus(_card.cardNumber, 2).toPromise();
      if(!_UpdateStatusCard || _UpdateStatusCard.error) throw _UpdateStatusCard;

      */
      // Response
      return true;
      
    } catch(err) {
      console.log(err);
      return false;
    }
  }



}
